import * as React from 'react';
import { connect } from 'react-redux';

const classNames = require('classnames');

import Utils from '../common/utils';

import { Button } from '../components/buttons';
import { IconTriangleLeft, IconTriangleRight } from '../components/icons';

interface Props {
	className?: string;
	workflow: string;
	title?: string;
	option?: any;
	children?: {};
	actionChildren?: {};
	onCustomerPolicySelect: (plan: CustomerPolicy) => void;
	isLoading?: boolean;

	selectPolicyOptionsEnabled: boolean;
}
const renderWorkflowAPlan = (props: Props) => {
	const { children, option: { coverageAmount, term, rate } } = props;
	return (
		<div className="quote-plan-content">
			<div className="d-inline-flex align-items-center mb-3 px-1 bg-info-dark text-white">
				<IconTriangleRight className="svg-inline" />
				<div className="media-body mx-1">First two months FREE!</div>
				<IconTriangleLeft className="svg-inline" />
			</div>
			<h2 className="quote-plan-title text-secondary">
				{
					coverageAmount != null && (
						<span className="d-block">{Utils.formatCurrency(coverageAmount, 0)} coverage</span>
					)
				}
				{term && (
					<small className="d-block">
						<em className="strong">
							{coverageAmount != null && ` for a `}
							{term} year term
									</em>
					</small>
				)}
			</h2>
			<h3 className="quote-plan-subtitle text-secondary mt-3">
				{rate && <span>{Utils.formatCurrency(rate, 2)}/month</span>}
			</h3>
			{children}
		</div>
	);
};
const renderWorkflowBPlan = (props: Props) => {
	const { children, option: { coverageAmount, term, rate } } = props;
	return (
		<div className="quote-plan-content">
			<div className="d-inline-flex align-items-center mb-3 px-1 bg-info-dark text-white">
				<IconTriangleRight className="svg-inline" />
				<div className="media-body mx-1">First two months FREE!</div>
				<IconTriangleLeft className="svg-inline" />
			</div>
			<h2 className="quote-plan-title text-secondary">
				{Utils.formatCurrency(rate, 2)}/month
			</h2>
			<h3 className={`quote-plan-subtitle text-secondary${coverageAmount != null ? ' mt-3' : ''}`}>
				{coverageAmount != null && (
					<span className="d-block">{Utils.formatCurrency(coverageAmount, 0)} coverage</span>
				)}
				{term && (
					<small className="d-block">
						<em className="strong">
							{coverageAmount != null && ` for a `}
							{term} year term
										</em>
					</small>
				)}
			</h3>
			{children}
		</div>
	);
};
const renderWorkflowCPlan = (props: Props) => {
	const { children, option: { term, rate } } = props;
	return (
		<div className="quote-plan-content">
			<div className="d-inline-flex align-items-center mb-3 px-1 bg-info-dark text-white">
				<IconTriangleRight className="svg-inline" />
				<div className="media-body mx-1">First two months FREE!</div>
				<IconTriangleLeft className="svg-inline" />
			</div>
			<h2 className="quote-plan-title text-secondary">
				{term && <span className="d-block">{term} year term</span>}
			</h2>
			<h3 className="quote-plan-subtitle text-secondary mt-3">
				{rate && <span>{Utils.formatCurrency(rate, 2)}/month</span>}
			</h3>
			{children}
		</div>
	);
};
const QuotePlan: React.StatelessComponent<Props> = props => {
	const {
		className,
		workflow,
		option,
		actionChildren,
		onCustomerPolicySelect,
		isLoading,
	} = props;

	if (isLoading) {
		return (
			<div className={classNames('quote-plan loading', className)}>
				<div className="quote-plan-content">
					<h2 className="quote-plan-title has-loading-text" />
					<h3 className="quote-plan-subtitle mt-3">
						<span className="d-block has-loading-text" />
						<small className="d-block has-loading-text" />
					</h3>
				</div>
				<div className="quote-plan-actions mt-4">
					<Button className="btn-primary btn-block has-loading-text" disabled={true} />
					<Button className="text-primary btn-block has-loading-text" disabled={true} />
				</div>
			</div>
		);
	}
	else {
		let plan;
		if (workflow === 'A') {
			plan = renderWorkflowAPlan(props);
		} else if (workflow === 'B') {
			plan = renderWorkflowBPlan(props);
		} else if (workflow === 'C') {
			plan = renderWorkflowCPlan(props);
		}

		return (
			<div className={classNames('quote-plan content-fade-in', className)}>
				{plan}
				<div className="quote-plan-actions">
					<Button
						className="btn-primary btn-block"
						onClick={() => onCustomerPolicySelect(option)}
						disabled={!props.selectPolicyOptionsEnabled}
					>
						Get started
					</Button>
					{actionChildren}
				</div>
			</div>
		);
	}
};

function mapStateToProps(state: any) {
	return {
		selectPolicyOptionsEnabled: state.settings.selectPolicyOptionsEnabled
	};
}

export default connect(mapStateToProps)(QuotePlan);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/QuotePlan.tsx